import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}
const DotsHorizIcon: FunctionComponent<Props> = ({
  className,
  fill = "currentColor",
  width = 24,
  height = 8,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 8"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4" cy="4" r="2" fill={fill} />
      <circle cx="12" cy="4" r="2" fill={fill} />
      <circle cx="20" cy="4" r="2" fill={fill} />
    </svg>
  );
};

export default DotsHorizIcon;
